//
//
//
//
//
//
//
//
//
//
//
//
//

import { throttle, debounce } from 'throttle-debounce'
import { mapState, mapGetters } from 'vuex'

const paddingTop = 10,
  paddingBottom = 26
const paddingX = 26

function hexToRgba(sHex, alpha = 1) {
  // 十六进制颜色值的正则表达式
  let reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
  /* 16进制颜色转为RGB格式 */
  let sColor = sHex.toLowerCase()
  if (sColor && reg.test(sColor)) {
    if (sColor.length === 4) {
      let sColorNew = '#'
      for (let i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1))
      }
      sColor = sColorNew
    }
    // 处理六位的颜色值
    let sColorChange = []
    for (let i = 1; i < 7; i += 2) {
      sColorChange.push(parseInt('0x' + sColor.slice(i, i + 2)))
    }
    // return sColorChange.join(',')
    // 或
    return 'rgba(' + sColorChange.join(',') + ',' + alpha + ')'
  } else {
    return sColor
  }
}

function fillCircle(ctx, x, y, r) {
  const PI2 = 2 * Math.PI
  ctx.beginPath()
  ctx.arc(x, y, r, 0, PI2)
  ctx.fill()
}

function drawBackground(ctx, style, w, h, noShadow) {
  ctx.save()
  if (!noShadow) {
    ctx.shadowOffsetX = ctx.shadowOffsetY = 2
    ctx.shadowBlur = paddingX / 2
    ctx.shadowColor = 'rgba(0, 0, 0, 0.2)'
  }
  ctx.fillStyle = style.boardColor
  ctx.fillRect(paddingX, paddingTop, w - paddingX * 2, h - paddingBottom - paddingTop)
  ctx.restore()
}

function drawCoord(ctx, style, w, h, s, cs) {
  ctx.save()
  ctx.font = style.coordFontStyle + ' ' + Math.min(20, cs * 0.6) + 'px ' + style.coordFontFamily
  ctx.textAlign = 'center'
  ctx.textBaseline = 'middle'
  ctx.fillStyle = style.coordColor

  // 左侧坐标
  ctx.save()
  ctx.translate(paddingX / 2, paddingTop + cs / 2)
  for (let i = 0; i < s; i++) {
    ctx.fillText(s - i, 0, cs * i, paddingX)
  }

  // 右侧坐标
  ctx.translate(w - paddingX, 0)
  for (let i = 0; i < s; i++) {
    ctx.fillText(s - i, 0, cs * i, paddingX)
  }
  ctx.restore()

  // 底部坐标
  ctx.translate(paddingX + cs / 2, h - paddingBottom / 2)
  for (let i = 0; i < s; i++) {
    ctx.fillText(String.fromCharCode('A'.charCodeAt(0) + i), cs * i, 0)
  }

  ctx.restore()
}

function drawBoard(ctx, style, s, cs) {
  let si = s - 1

  ctx.save()
  ctx.strokeStyle = ctx.fillStyle = style.lineColor
  ctx.translate(paddingX + cs / 2, paddingTop + cs / 2)
  ctx.scale(cs, cs)

  // 网格线
  ctx.lineWidth = style.lineWidth
  ctx.beginPath()
  for (let i = 1; i < si; i++) {
    ctx.moveTo(i, 0)
    ctx.lineTo(i, si)
    ctx.moveTo(0, i)
    ctx.lineTo(si, i)
  }
  ctx.stroke()

  // 画边框
  ctx.lineWidth = style.lineWidth * 2.5
  ctx.beginPath()
  ctx.moveTo(0, 0)
  ctx.lineTo(si, 0)
  ctx.lineTo(si, si)
  ctx.lineTo(0, si)
  ctx.closePath()
  ctx.stroke()

  // 画星位
  let starPad = Math.floor(s / 5)
  let starCenter = Math.floor(s / 2)
  let starRadius = style.starRadiusScale
  fillCircle(ctx, starPad, starPad, starRadius)
  fillCircle(ctx, si - starPad, starPad, starRadius)
  fillCircle(ctx, starPad, si - starPad, starRadius)
  fillCircle(ctx, si - starPad, si - starPad, starRadius)
  fillCircle(ctx, starCenter, starCenter, starRadius)

  ctx.restore()
}

function drawPiece(ctx, style, cs, position, end) {
  let radius = style.pieceScale / 2
  ctx.save()
  ctx.translate(paddingX + cs / 2, paddingTop + cs / 2)
  ctx.scale(cs, cs)

  ctx.lineWidth = style.pieceStrokeWidth
  ctx.fillStyle = style.pieceBlack
  ctx.strokeStyle = style.pieceStrokeBlack

  end = Math.min(end, position.length)
  for (let i = 0; i < end; i += 2) {
    let pos = position[i]
    fillCircle(ctx, pos[0], pos[1], radius)
    if (style.pieceStrokeWidth > 0) ctx.stroke()
  }

  ctx.fillStyle = style.pieceWhite
  ctx.strokeStyle = style.pieceStrokeWhite
  for (let i = 1; i < end; i += 2) {
    let pos = position[i]
    fillCircle(ctx, pos[0], pos[1], radius)
    if (style.pieceStrokeWidth > 0) ctx.stroke()
  }

  ctx.restore()
}

function drawIndex(ctx, style, cs, position, end, startIndex, highlight) {
  ctx.save()
  ctx.font = style.indexFontStyle + ' ' + style.indexScale * cs + 'px ' + style.indexFontFamily
  ctx.textAlign = 'center'
  ctx.textBaseline = 'middle'
  ctx.translate(paddingX + cs / 2, paddingTop + cs / 2)

  end = Math.min(end, position.length)
  for (let i = startIndex; i < end - 1; i += 1) {
    let pos = position[i]
    let text = i - startIndex + 1
    ctx.fillStyle = i % 2 == 0 ? style.indexColorBlack : style.indexColorWhite
    ctx.fillText(text, cs * pos[0], cs * pos[1], cs)
  }

  if (end > startIndex) {
    let pos = position[end - 1]
    if (highlight) ctx.fillStyle = style.lastStepColor
    else ctx.fillStyle = end % 2 == 1 ? style.indexColorBlack : style.indexColorWhite
    ctx.fillText(end - startIndex, cs * pos[0], cs * pos[1], cs)
  }

  ctx.restore()
}

function drawLastStep(ctx, style, cs, position, end) {
  end = Math.min(end, position.length)
  if (end <= 0) return
  ctx.save()
  ctx.fillStyle = style.lastStepColor
  ctx.translate(paddingX + cs / 2, paddingTop + cs / 2)
  ctx.scale(cs, cs)
  let pos = position[end - 1]
  fillCircle(ctx, pos[0], pos[1], style.lastStepScale)
  ctx.restore()
}

function drawWinline(ctx, style, cs, winline) {
  ctx.save()
  ctx.lineCap = 'round'
  ctx.strokeStyle = style.winlineColor
  ctx.lineWidth = style.winlineWidth
  ctx.translate(paddingX + cs / 2, paddingTop + cs / 2)
  ctx.scale(cs, cs)

  ctx.beginPath()
  ctx.moveTo(winline[0][0], winline[0][1])
  ctx.lineTo(winline[1][0], winline[1][1])
  ctx.stroke()

  ctx.restore()
}

function drawRealtime(ctx, style, cs, moves) {
  ctx.save()
  ctx.translate(paddingX + cs / 2, paddingTop + cs / 2)
  ctx.scale(cs, cs)

  // 分析所有点的评估值，找出最强点
  let bestEval = null
  let bestIndex = -1
  let bestType = null  // 'lost' 或 'best'
  let allPoints = [...moves.lost, ...moves.best]
  
  for (let i = 0; i < allPoints.length; i++) {
    let p = allPoints[i]
    let evalValue = p.eval || null
    if (evalValue && typeof evalValue === 'string') {
      // 将评估值转换为数值进行比较
      let evalNum = 0
      if (evalValue.startsWith('+M')) {
        evalNum = 40000 - parseInt(evalValue.substring(2))
      } else if (evalValue.startsWith('-M')) {
        evalNum = -40000 + parseInt(evalValue.substring(2))
      } else {
        evalNum = parseFloat(evalValue) || 0
      }
      
      if (bestEval === null || evalNum > bestEval) {
        bestEval = evalNum
        bestIndex = i
        bestType = i < moves.lost.length ? 'lost' : 'best'
      }
    }
  }

  // 绘制白色必败点
  ctx.fillStyle = style.lostMoveColor
  for (let i = 0; i < moves.lost.length; i++) {
    let p = moves.lost[i]
    let pos = p.pos || p  // 兼容旧格式
    let evalValue = p.eval || null
    
    // 判断是否为必败点
    let isMateLose = false
    if (evalValue && typeof evalValue === 'string') {
      isMateLose = evalValue.startsWith('-M')
    }
    
    // 判断这个点是否是最强点
    let isBestPoint = (bestType === 'lost' && bestIndex === i)
    
    if (isMateLose && isBestPoint) {
      // 最强必败点显示较大的白色圆点
      fillCircle(ctx, pos[0], pos[1], style.bestMoveScale)
    } else {
      // 普通必败点显示较小的白色圆点
      fillCircle(ctx, pos[0], pos[1], style.realtimeMoveScale)
    }
  }

  // 绘制红色最佳点，区分必胜点和普通强点
  for (let i = 0; i < moves.best.length; i++) {
    let p = moves.best[i]
    let pos = p.pos || p  // 兼容旧格式
    let evalValue = p.eval || null
    
    // 判断是否为必胜点（只有+M开头才是必胜）
    let isMate = false
    let isMateLose = false
    if (evalValue && typeof evalValue === 'string') {
      isMate = evalValue.startsWith('+M')
      isMateLose = evalValue.startsWith('-M')
    }
    
    // 判断这个点是否是最强点
    let isBestPoint = (bestType === 'best' && bestIndex - moves.lost.length === i)
    
    if (isMateLose) {
      // 如果是必败点（-M），显示为白色点
      ctx.fillStyle = style.lostMoveColor
      if (isBestPoint) {
        // 最强必败点显示较大的白色圆点
        fillCircle(ctx, pos[0], pos[1], style.bestMoveScale)
      } else {
        // 普通必败点显示较小的白色圆点
        fillCircle(ctx, pos[0], pos[1], style.realtimeMoveScale)
      }
    } else if (isMate) {
      // 必胜点显示更大的红色圆点
      ctx.fillStyle = style.bestMoveColor
      fillCircle(ctx, pos[0], pos[1], style.bestMoveScale)
    } else {
      // 非必胜点（包括最强点）都显示较小的红色圆点
      ctx.fillStyle = style.bestMoveColor
      fillCircle(ctx, pos[0], pos[1], style.realtimeMoveScale)
    }
  }

  // 在红点上显示eval数值
  ctx.textAlign = 'center'
  ctx.textBaseline = 'bottom'  // 文字底部对齐，这样显示在点的上方
  ctx.fillStyle = '#FF0000'  // 红色文字
  
  // 设置字体大小，更小一些
  let fontSize = style.pvEvalScale * 0.6  // 相对于格子大小的比例，从0.8改为0.6
  ctx.font = style.pvEvalFontStyle + ' ' + fontSize + 'px ' + style.pvEvalFontFamily
  
  // 绘制最佳点的eval数值
  for (let i = 0; i < moves.best.length; i++) {
    let p = moves.best[i]
    let pos = p.pos || p  // 兼容旧格式
    let evalValue = p.eval || null
    
    if (evalValue && typeof evalValue === 'string') {
      let isMateLose = evalValue.startsWith('-M')
      
      // 只在红点（非必败点）上显示eval数值，显示在点的上方
      if (!isMateLose) {
        ctx.fillText(evalValue, pos[0], pos[1] - 0.35, 0.9)  // Y坐标向上偏移0.35，最大宽度0.9个格子
      }
    }
  }

  ctx.restore()
}

function drawPvEval(ctx, showType, style, cs, pv) {
  ctx.textAlign = 'center'
  ctx.textBaseline = 'middle'

  let halfcs = cs / 2
  let bgColor = hexToRgba(style.boardColor, style.pvEvalAlpha)
  ctx.translate(paddingX + halfcs, paddingTop + halfcs)

  for (let i = pv.length - 1; i >= 0; i -= 1) {
    if (pv[i].bestline && pv[i].bestline.length > 0) {
      let pos = pv[i].bestline[0]
      let x = cs * pos[0]
      let y = cs * pos[1]
      ctx.fillStyle = bgColor
      ctx.fillRect(x - halfcs, y - halfcs, cs, cs)
      ctx.fillStyle = i > 0 ? style.thoughtMoveColor : style.bestMoveColor

      ctx.font =
        style.pvEvalFontStyle + ' ' + style.pvEvalScale * cs + 'px ' + style.pvEvalFontFamily
      if (showType == 1) {
        ctx.fillText(pv[i].eval, x, y, cs * 0.95)
      } else if (showType == 2) {
        if (pv[i].winrate == 0.0 || pv[i].winrate == 1.0) ctx.fillText(pv[i].eval, x, y, cs * 0.95)
        else ctx.fillText((pv[i].winrate * 100).toFixed(1), x, y, cs * 0.95)
      } else {
        ctx.fillText(pv[i].eval, x, y - cs * 0.2, cs * 0.95)
        ctx.font =
          (style.pvEvalFontStyle * 2) / 3 +
          ' ' +
          style.pvEvalScale * cs * 0.8 +
          'px ' +
          style.pvEvalFontFamily
        ctx.fillText(pv[i].depth + '-' + pv[i].seldepth, x, y + cs * 0.2, cs * 0.95)
      }
    }
  }
}

function drawSelection(ctx, style, cs, pos) {
  ctx.save()
  ctx.strokeStyle = style.selectionStrokeColor
  ctx.lineWidth = style.selectionStrokeWidth
  ctx.translate(paddingX + cs / 2, paddingTop + cs / 2)
  ctx.scale(cs, cs)

  ctx.beginPath()
  ctx.moveTo(pos[0] - 0.5, pos[1] - 0.5)
  ctx.lineTo(pos[0] + 0.5, pos[1] - 0.5)
  ctx.lineTo(pos[0] + 0.5, pos[1] + 0.5)
  ctx.lineTo(pos[0] - 0.5, pos[1] + 0.5)
  ctx.closePath()
  ctx.stroke()

  ctx.restore()
}

function drawForbid(ctx, style, cs, forbid) {
  ctx.save()
  ctx.strokeStyle = style.forbidStrokeColor
  ctx.lineWidth = style.forbidStrokeWidth
  ctx.lineCap = 'round'
  ctx.translate(paddingX + cs / 2, paddingTop + cs / 2)
  ctx.scale(cs, cs)

  const CrossSize = 0.22

  for (let pos of forbid) {
    ctx.beginPath()
    ctx.moveTo(pos[0] - CrossSize, pos[1] - CrossSize)
    ctx.lineTo(pos[0] + CrossSize, pos[1] + CrossSize)
    ctx.stroke()
    ctx.beginPath()
    ctx.moveTo(pos[0] + CrossSize, pos[1] - CrossSize)
    ctx.lineTo(pos[0] - CrossSize, pos[1] + CrossSize)
    ctx.stroke()
  }

  ctx.restore()
}

function drawAttackFour(ctx, style, cs, attackFour) {
  ctx.save()
  ctx.translate(paddingX + cs / 2, paddingTop + cs / 2)
  ctx.scale(cs, cs)
  ctx.lineWidth = 0.05  // 冲四线宽，稍粗一点

  const CircleRadius = 0.18  // 冲四圆圈半径，比活三大一点

  for (let attackFourPoint of attackFour) {
    let pos = attackFourPoint.pos || attackFourPoint  // 兼容旧格式
    let color = attackFourPoint.color || 'black'  // 默认黑色
    
    // 根据颜色设置不同的样式
    if (color === 'black') {
      ctx.strokeStyle = '#FF4444'  // 红色边框 - 黑棋冲四点
    } else {
      ctx.strokeStyle = '#4444FF'  // 蓝色边框 - 白棋冲四点  
    }
    
    // 绘制空心圆圈标记冲四点
    ctx.beginPath()
    ctx.arc(pos[0], pos[1], CircleRadius, 0, 2 * Math.PI)
    ctx.stroke()  // 只描边，不填充
  }

  ctx.restore()
}

function drawLivingThree(ctx, style, cs, livingThree) {
  if (!livingThree || livingThree.length === 0) return
  
  ctx.save()
  ctx.translate(paddingX + cs / 2, paddingTop + cs / 2)
  ctx.scale(cs, cs)
  ctx.lineWidth = 0.04  // 活三线宽，比冲四稍细
  
  const CircleRadius = 0.12  // 活三圆圈半径，比冲四小一点
  
  for (let point of livingThree) {
    let pos = point.pos || point  // 兼容旧格式
    let color = point.color || 'black'  // 默认黑色
    
    // 根据颜色设置样式，与冲四保持一致
    if (color === 'black') {
      ctx.strokeStyle = '#FF4444'  // 红色表示黑棋活三，与冲四颜色一致
    } else {
      ctx.strokeStyle = '#4444FF'  // 蓝色表示白棋活三，与冲四颜色一致
    }
    
    // 绘制空心圆圈
    ctx.beginPath()
    ctx.arc(pos[0], pos[1], CircleRadius, 0, 2 * Math.PI)
    ctx.stroke()  // 只描边，不填充
  }
  
  ctx.restore()
}



function drawVCF(ctx, style, cs, vcfSequence) {
  if (!vcfSequence || vcfSequence.length === 0) {
    return
  }
  
  ctx.save()
  ctx.translate(paddingX + cs / 2, paddingTop + cs / 2)
  ctx.scale(cs, cs)
  
  const CircleRadius = 0.25  // VCF点圆圈半径，比冲四(0.18)更大
  
  // 绘制VCF点，包含数字标记
  for (let i = 0; i < vcfSequence.length; i++) {
    let vcfStep = vcfSequence[i]
    let pos = vcfStep.pos || vcfStep  // 兼容旧格式
    let stepNumber = vcfStep.step || (i + 1)  // 步骤编号
    
    if (!pos || !Array.isArray(pos) || pos.length < 2) {
      continue
    }
    
    // 绘制实心圆圈
    ctx.fillStyle = '#FF6600'  // 橙色填充
    ctx.strokeStyle = '#CC5500'  // 深橙色边框
    ctx.lineWidth = 0.03
    ctx.beginPath()
    ctx.arc(pos[0], pos[1], CircleRadius, 0, 2 * Math.PI)
    ctx.fill()
    ctx.stroke()
    
    // 绘制步骤编号
    ctx.save()
    ctx.fillStyle = '#FFFFFF'  // 白色文字
    let fontSize = CircleRadius * 0.8  // 增大字体，从0.6改为0.8
    ctx.font = 'bold ' + fontSize + 'px Arial'
    ctx.textAlign = 'center'
    ctx.textBaseline = 'middle'
    ctx.fillText(stepNumber.toString(), pos[0], pos[1])
    ctx.restore()
  }
  
  ctx.restore()
}

export default {
  name: 'Board',
  props: {
    isAiTurn: Boolean,
    previewPv: Object,
  },
  data: function () {
    return {
      debouncedRedrawAllLayers: debounce(50, this.redrawAllLayers),
      throttledDrawRealtimeLayer: throttle(10, this.drawRealtimeLayer),
      selecting: false,
      selectedCoord: [0, 0],
      pressed: false,
      cancelMouse: false,
      ratioOverride: null,
      end: Infinity,
    }
  },
  computed: {
    ...mapState('position', {
      boardSize: 'size',
      position: 'position',
      winline: 'winline',
    }),
    ...mapState('settings', [
      'boardStyle',
      'indexOrigin',
      'showCoord',
      'showDetail',
      'showPvEval',
      'showWinrate',
      'showIndex',
      'showLastStep',
      'showWinline',
      'showForbid',
      'showAttackFour',
      'showVCF',
      'showLivingThree',
      'showThreatAnalysis',
      'clickCheck',
    ]),
    ...mapState('ai', {
      realtime: (state) => state.outputs.realtime,
      pv: (state) => state.outputs.pv,
      forbid: (state) => state.outputs.forbid,
      attackFour: (state) => state.outputs.attackFour,
      vcf: (state) => state.outputs.vcf,
      livingThree: (state) => state.outputs.livingThree,
      threatAnalysis: (state) => state.outputs.threatAnalysis,
      thinking: 'thinking',
    }),
    ...mapState('settings', ['analyzeMode']),
    ...mapGetters('position', ['isInBoard']),
    context() {
      return (idx) => {
        return this.$refs['canvas' + idx].getContext('2d')
      }
    },
    canvasWidth() {
      return this.$store.getters.boardCanvasWidth
    },
    canvasHeight() {
      return this.canvasWidth - 2 * paddingX + paddingBottom + paddingTop
    },
    boardWidth() {
      return this.canvasWidth - 2 * paddingX
    },
    canvasStyle() {
      return {
        width: this.canvasWidth + 'px',
        height: this.canvasHeight + 'px',
      }
    },
    renderRatio() {
      // 屏幕的设备像素比(解决高DPI屏模糊问题)
      return this.ratioOverride || window.devicePixelRatio || 1
    },
    renderWidth() {
      return this.canvasWidth * this.renderRatio
    },
    renderHeight() {
      return this.canvasHeight * this.renderRatio
    },
  },
  methods: {
    drawBoardLayer(ctx, noclear) {
      ctx = ctx || this.context('Board')
      let width = this.canvasWidth
      let height = this.canvasHeight
      let cellSize = this.boardWidth / this.boardSize

      ctx.save()
      ctx.scale(this.renderRatio, this.renderRatio)
      if (!noclear) ctx.clearRect(0, 0, width, height)

      drawBackground(ctx, this.boardStyle, width, height, noclear)
      if (this.showCoord) drawCoord(ctx, this.boardStyle, width, height, this.boardSize, cellSize)
      drawBoard(ctx, this.boardStyle, this.boardSize, cellSize)

      ctx.restore()
    },
    drawPieceLayer(ctx, noclear) {
      ctx = ctx || this.context('Piece')
      let cellSize = this.boardWidth / this.boardSize
      ctx.save()
      ctx.scale(this.renderRatio, this.renderRatio)
      if (!noclear) ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight)

      if (this.previewPv) {
        let previewPosition = this.previewPv.position.concat(this.previewPv.pv)
        drawPiece(ctx, this.boardStyle, cellSize, previewPosition, Infinity)
        drawIndex(
          ctx,
          this.boardStyle,
          cellSize,
          previewPosition,
          Infinity,
          this.previewPv.position.length,
          this.showLastStep
        )
      } else {
        drawPiece(ctx, this.boardStyle, cellSize, this.position, this.end)
        if (this.showWinline && this.winline.length > 0 && this.end >= this.position.length)
          drawWinline(ctx, this.boardStyle, cellSize, this.winline)
        if (this.showIndex)
          drawIndex(
            ctx,
            this.boardStyle,
            cellSize,
            this.position,
            this.end,
            this.indexOrigin,
            this.showLastStep
          )
        else if (this.showLastStep)
          drawLastStep(ctx, this.boardStyle, cellSize, this.position, this.end)
      }

      ctx.restore()
    },
    drawRealtimeLayer(ctx, noclear) {
      ctx = ctx || this.context('Realtime')
      let cellSize = this.boardWidth / this.boardSize
      ctx.save()
      ctx.scale(this.renderRatio, this.renderRatio)
      if (!noclear) ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight)

      if (this.showForbid && !this.thinking && !this.previewPv) {
        drawForbid(ctx, this.boardStyle, cellSize, this.forbid)
      }
      
      if (this.showAttackFour && !this.thinking && !this.previewPv) {
        drawAttackFour(ctx, this.boardStyle, cellSize, this.attackFour)
      }
      
      if (this.showVCF && !this.thinking && !this.previewPv) {
        drawVCF(ctx, this.boardStyle, cellSize, this.vcf)
      }
      
      if (this.showLivingThree && !this.thinking && !this.previewPv) {
        drawLivingThree(ctx, this.boardStyle, cellSize, this.livingThree)
      }
      


      if (this.selecting) drawSelection(ctx, this.boardStyle, cellSize, this.selectedCoord)
      else if (!this.previewPv) {
        // 显示实时分析数据（分析模式或正常思考时都显示）
        if (this.showDetail && (this.analyzeMode || this.thinking)) drawRealtime(ctx, this.boardStyle, cellSize, this.realtime)
        if (this.showPvEval > 0 && this.pv.length > 0 && this.thinking)
          drawPvEval(ctx, this.showPvEval, this.boardStyle, cellSize, this.pv)
      }

      ctx.restore()
    },
    redrawAllLayers(ctx, noclear) {
      this.drawBoardLayer(ctx, noclear)
      this.drawPieceLayer(ctx, noclear)
      this.drawRealtimeLayer(ctx, noclear)
    },
    screenshot() {
      this.ratioOverride = 2048 / this.canvasWidth
      let ctx = this.context('Jpg')
      ctx.save()
      ctx.scale(this.renderRatio, this.renderRatio)
      ctx.fillStyle = '#FFFFFF'
      ctx.fillRect(0, 0, this.canvasWidth, this.canvasHeight)
      ctx.restore()

      this.redrawAllLayers(ctx, true)
      this.ratioOverride = null
      return ctx.canvas.toDataURL('image/jpeg')
    },
    exportGIF(startIndex, delay, callback) {
      let ctx = this.context('Gif')
      this.ratioOverride = ctx.canvas.width / this.canvasWidth
      // eslint-disable-next-line
      let gif = new GIF({
        workers: 8,
        quality: 2,
        width: ctx.canvas.width,
        height: ctx.canvas.height,
        workerScript: process.env.BASE_URL + 'lib/gif.worker.js',
      })

      for (this.end = startIndex; this.end <= this.position.length; this.end++) {
        ctx.save()
        ctx.fillStyle = '#FFFFFF'
        ctx.scale(this.renderRatio, this.renderRatio)
        ctx.fillRect(0, 0, this.canvasWidth, this.canvasHeight)
        ctx.restore()
        this.drawBoardLayer(ctx, true)
        this.drawPieceLayer(ctx, true)
        gif.addFrame(ctx, { copy: true, delay: (this.end == this.position.length ? 3 : 1) * delay })
      }

      this.end = Infinity
      this.ratioOverride = null

      gif.on('finished', callback)
      gif.render()
    },
    onMouseDown(event) {
      if (this.clickCheck == 2) {
        if (event.type === 'touchstart') {
          this.cancelMouse = true
          event.button = 0
          if (!event.pageX) event.pageX = event.touches[0].pageX
          if (!event.pageY) event.pageY = event.touches[0].pageY
        } else if (this.cancelMouse) {
          this.cancelMouse = false
          return
        }
      }

      let x = event.pageX - this.$refs.canvasBoard.getBoundingClientRect().left
      let y = event.pageY - this.$refs.canvasBoard.getBoundingClientRect().top
      let cellSize = this.boardWidth / this.boardSize
      x = Math.floor((x - paddingX) / cellSize)
      y = Math.floor((y - paddingTop) / cellSize)

      if (event.button != 0) {
        this.$emit('clicked', { x, y, button: event.button })
        return
      } else if (this.winline.length > 0) return

      if (this.clickCheck == 0 || this.isAiTurn)
        this.$emit('clicked', { x, y, button: event.button })
      else if (this.clickCheck == 1) {
        if (this.selecting) {
          let dx = Math.abs(x - this.selectedCoord[0])
          let dy = Math.abs(y - this.selectedCoord[1])
          if (Math.max(dx, dy) <= 1)
            this.$emit('clicked', {
              x: this.selectedCoord[0],
              y: this.selectedCoord[1],
              button: event.button,
            })
        } else {
          this.selectedCoord = [x, y]
        }
        this.selecting = !this.selecting
      } else if (this.clickCheck == 2) {
        this.pressed = true
        this.selectedCoord = [x, y - 2]
        this.selecting = this.isInBoard(this.selectedCoord)
      }
    },
    onMouseUp(event) {
      if (!this.pressed) return

      if (event.type === 'touchend') {
        event.preventDefault()
        event.button = 0
      }

      this.$emit('clicked', {
        x: this.selectedCoord[0],
        y: this.selectedCoord[1],
        button: event.button,
      })

      this.selecting = false
      this.pressed = false
    },
    onMouseMove(event) {
      if (!this.pressed) return

      if (event.type === 'touchmove') {
        event.preventDefault()
        event.button = 0
        if (!event.pageX) event.pageX = event.touches[0].pageX
        if (!event.pageY) event.pageY = event.touches[0].pageY
      }

      let x = event.pageX - this.$refs.canvasBoard.getBoundingClientRect().left
      let y = event.pageY - this.$refs.canvasBoard.getBoundingClientRect().top
      let cellSize = this.boardWidth / this.boardSize
      x = Math.floor((x - paddingX) / cellSize)
      y = Math.floor((y - paddingTop) / cellSize)

      let oldCoord = this.selectedCoord
      this.selectedCoord = [x, y - 2]
      this.selecting = this.isInBoard(this.selectedCoord)

      if (
        this.selecting &&
        (oldCoord[0] != this.selectedCoord[0] || oldCoord[1] != this.selectedCoord[1])
      ) {
        this.throttledDrawRealtimeLayer()
      }
    },
  },
  watch: {
    '$store.state.screenWidth': function () {
      this.debouncedRedrawAllLayers()
    },
    '$store.state.screenHeight': function () {
      this.debouncedRedrawAllLayers()
    },
    boardSize() {
      this.debouncedRedrawAllLayers()
    },
    position: {
      handler() {
        this.drawPieceLayer()
        // 只有在用户主动开启冲四点且引擎不在思考时才检查冲四点
        if (this.showAttackFour && !this.thinking) {
          this.$store.dispatch('ai/checkAttackFour')
        }
        // 只有在用户主动开启活三且引擎不在思考时才检查活三
        if (this.showLivingThree && !this.thinking) {
          this.$store.dispatch('ai/checkLivingThree')
        }
        // 只有在用户主动开启威胁分析且引擎不在思考时才检查威胁分析
        if (this.showThreatAnalysis && !this.thinking) {
          this.$store.dispatch('ai/checkThreatAnalysis')
        }
        // 只有在用户主动开启VCF且引擎不在思考时才检查VCF
        if (this.showVCF && !this.thinking) {
          this.$store.dispatch('ai/checkVCF')
        }
      },
      deep: true,
    },
    realtime: {
      handler() {
        if (this.showDetail) this.throttledDrawRealtimeLayer()
      },
      deep: true,
    },
    pv: {
      handler() {
        if (this.showPvEval > 0) this.throttledDrawRealtimeLayer()
      },
      deep: true,
    },
    forbid() {
      if (this.showForbid) this.drawRealtimeLayer()
    },
    attackFour() {
      if (this.showAttackFour) this.drawRealtimeLayer()
    },
    vcf() {
      if (this.showVCF) this.drawRealtimeLayer()
    },
    livingThree() {
      if (this.showLivingThree) this.drawRealtimeLayer()
    },
    threatAnalysis() {
      if (this.showThreatAnalysis) this.drawRealtimeLayer()
    },
    previewPv() {
      this.drawPieceLayer()
      this.drawRealtimeLayer()
    },
    indexOrigin() {
      this.drawPieceLayer()
    },
    showCoord() {
      this.drawBoardLayer()
    },
    showDetail() {
      this.drawRealtimeLayer()
    },
    showPvEval() {
      this.drawRealtimeLayer()
    },
    showIndex() {
      this.drawPieceLayer()
    },
    showLastStep() {
      this.drawPieceLayer()
    },
    showWinline() {
      this.drawPieceLayer()
    },
    showForbid() {
      this.drawRealtimeLayer()
    },
    showAttackFour() {
      this.drawRealtimeLayer()
      if (this.showAttackFour) {
        this.$store.dispatch('ai/checkAttackFour')
      }
    },
    showVCF() {
      this.drawRealtimeLayer()
      if (this.showVCF) {
        this.$store.dispatch('ai/checkVCF')
      }
    },
    showLivingThree() {
      this.drawRealtimeLayer()
      if (this.showLivingThree) {
        this.$store.dispatch('ai/checkLivingThree')
      }
    },
    showThreatAnalysis() {
      this.drawRealtimeLayer()
      if (this.showThreatAnalysis) {
        this.$store.dispatch('ai/checkThreatAnalysis')
      }
    },
    selecting() {
      this.throttledDrawRealtimeLayer()
    },
    boardStyle: {
      handler() {
        this.debouncedRedrawAllLayers()
      },
      deep: true,
    },
  },
  mounted() {
    this.redrawAllLayers()
    window.addEventListener('mousemove', throttle(50, this.onMouseMove))
    window.addEventListener('mouseup', this.onMouseUp)
    window.addEventListener('touchmove', throttle(50, this.onMouseMove), {
      passive: false,
    })
    window.addEventListener('touchend', this.onMouseUp, { passive: false })
  },
}
